import React, {FC, useMemo} from 'react';
import {MaterialReactTable} from 'material-react-table';
import {Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';

interface CustomerListProps {
  isLoading: boolean;
  customers: OverviewCustomer[];
}

export const CustomerList: FC<CustomerListProps> = ({isLoading, customers}) => {
  const navigate = useNavigate();

  const columns = useMemo(
      () => [
        {accessorKey: 'id', header: 'ID'},
        {accessorKey: 'name', header: 'Name'},
        {accessorKey: 'dealer_name', header: 'Dealer'},
        {accessorKey: 'country', header: 'Country'},
        {accessorKey: 'printers_total', header: 'Total Printers'},
      ],
      [],
  );

  const data = useMemo(
      () =>
      isLoading ?
        [] :
        customers.map((customer) => ({
          id: customer.id,
          name: customer.name,
          dealer_name: customer?.dealer?.name || '',
          country: customer.country,
          printers_total: customer.printers_total || 0,
        })),
      [customers, isLoading],
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      enableSorting
      enableColumnFilters
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      muiTableBodyRowProps={({row}) => ({
        onClick: () => navigate(`/customer/${row.original.id}`),
        style: {cursor: 'pointer'},
      })}
      renderTopToolbarCustomActions={() =>
        <Typography variant="h6">Customers</Typography>
      }
    />
  );
};
